// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Cuba */
const CU = /^(?:(?:5\d|6[2-4])\d{6})$/;

export default CU;
